import { FC, useEffect } from 'react';
import { ArrowRight, Box } from '@doda/io-react/common';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { topCounselingTodoListTextGroupNoSelector } from '@doda/common/src/redux/features/abTest';
import { useAppDispatch } from '@doda/common/src/redux/hooks';
import { measureTopCounselingTodoListTextABAA } from '@doda/common/src/logics/todoList/analytics';
import styles from './index.module.scss';

export type TodoIconType =
  | 'counselingDate'
  | 'interviewDateSetting'
  | 'dateSetting'
  | 'message'
  | 'documentsOrder'
  | 'resumeFileUpload'
  | 'counseling'
  | 'desiredCondition';

/**
 * Todoリストのカードコンポネントのprops
 */
interface Props {
  title: string;
  url: string;
  iconType: TodoIconType;
  description?: string;
  /** Todoクリックハンドラー関数 */
  handleClickTodo: VoidFunction;
}

export const TodoListCard: FC<Props> = ({
  title,
  iconType,
  url,
  description,
  handleClickTodo,
}) => {
  // DODASITE-10654_TODO改善_カウ予約文言変更_web
  const dispatch = useAppDispatch();
  const topCounselingTodoListTextGroupNo = useSelector(
    topCounselingTodoListTextGroupNoSelector
  );
  const isTopCounselingTodoListTextTarget =
    iconType === 'counseling' && topCounselingTodoListTextGroupNo === '2';
  useEffect(() => {
    if (iconType === 'counseling') {
      if (
        topCounselingTodoListTextGroupNo === '1' ||
        topCounselingTodoListTextGroupNo === '2'
      ) {
        dispatch(
          measureTopCounselingTodoListTextABAA(topCounselingTodoListTextGroupNo)
        );
      }
    }
  }, [iconType, topCounselingTodoListTextGroupNo, dispatch]);

  return (
    <Box color="white" radius="4" boxShadow="blue">
      <a
        href={url}
        className={styles.toDoListCard__anchor}
        onClick={handleClickTodo}
      >
        <div
          className={classNames(
            styles.toDoListCard__icon,
            styles[`toDoListCard__icon--${iconType}`]
          )}
        />
        <div className={styles.toDoListCard__todoCardTitleArea}>
          <h4 className={styles.toDoListCard__todoCardTitle}>
            {isTopCounselingTodoListTextTarget
              ? 'カウンセリング日時を選択する'
              : title}
          </h4>
          {description && (
            <p className={styles.toDoListCard__todoCardDescription}>
              {description}
            </p>
          )}
        </div>
        <ArrowRight size="XS" color="gray" />
      </a>
    </Box>
  );
};
